<template>
  <div
    v-if="visible"
    :class="'fullscreen cvpreview' + className"
    :style="{ width: boxWidth || '', zIndex: `${zindex}` }"
    @contextmenu.prevent.stop="
      () => {
        return false
      }
    "
  >
    <div class="preview-title" @mousedown="domdrag($el, $event)">
      <h2>附件预览</h2>
      <div>
        <a v-if="!isMax" class="preview-max" href="javascript:;" title="最大化" @click="max"></a>
        <a v-else class="preview-revert" href="javascript:;" title="还原" @click="revert"></a>
        <a class="preview-close" href="javascript:;" title="关闭" @click="close"></a>
      </div>
    </div>
    <div class="preview-resizeL" @mousedown="resize($el, $event.target, true, false, false, true)"></div>
    <div class="preview-resizeT" @mousedown="resize($el, $event.target, false, true, true, false)"></div>
    <div class="preview-resizeR" @mousedown="resize($el, $event.target, false, false, false, true)"></div>
    <div class="preview-resizeB" @mousedown="resize($el, $event.target, false, false, true, false)"></div>
    <div class="preview-resizeLT" @mousedown="resize($el, $event.target, true, true, false, false)"></div>
    <div class="preview-resizeTR" @mousedown="resize($el, $event.target, false, true, false, false)"></div>
    <div class="preview-resizeBR" @mousedown="resize($el, $event.target, false, false, false, false)"></div>
    <div class="preview-resizeLB" @mousedown="resize($el, $event.target, true, false, false, false)"></div>
    <div v-if="dragLeft" class="preview-cover"></div>

    <div v-loading="loading" class="preview-content col-1" style="position:relative">
      <div
        v-if="file && (isAdmin || file.type == '推荐报告' || (isFinance && file.type == '付款通知书')) && userInservice"
        class="preview-download"
        @click="downloadFile"
      >
        下载
      </div>
      <!-- <div v-show="mask" class="embed-cover" @scroll.stop.prevent="onScroll"></div> -->
      <div v-show="isOfficeUrl" id="testIframeSalaryEdit" style="height:86vh !important; width: 100%"></div>
      <!-- <iframe
        v-show="isImgUrl"
        id="iframe"
        :src="viewUrl"
        width="100%"
        height="100%"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        scrolling="auto"
        allowtransparency="yes"
      />-->
      <div style="height: 86vh !important; overflow-y: auto;">
        <img v-show="suffix === 'jpg' || suffix === 'jpeg' || suffix === 'png' || isImgUrl" :src="previewUrl" />
      </div>
    </div>

    <!-- <div class="preview-close ft-danger"><i class="el-icon-close" @click="close" /></div> -->
  </div>
</template>

<script>
// TODO: 这里的预览需要用户已登录，为了方便复制了一份PublicPreview，不需要登录，且只能预览上传到publicUploads的文件
import { download } from '../../../project/src/constant/utils'
// import WPSOfficeSDK from '../../../assets/weboffice/web-office-sdk-v1.1.2.es'

export default {
  props: {
    width: { type: String, default: undefined },
    className: { type: String, default: '' },
  },
  data() {
    return {
      file: undefined,
      previewUrl: undefined,
      visible: false,
      boxWidth: this.width,
      loading: false,
      dragMinWidth: 250,
      dragMinHeight: 124,
      isMax: false,
      dragLeft: false,
      zindex: 1000,
      config: {
        document: {
          fileType: 'docx',
          key: '',
          title: '',
          permissions: {
            chat: false,
            comment: false,
            copy: false,
            download: false,
            edit: false,
            fillForms: false,
            modifyContentControl: false,
            modifyFilter: false,
            print: false,
            review: false,
            reviewGroups: null,
            commentGroups: {},
            userInfoGroups: null,
          },
          // url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/test1.html',
          url:
            'https://alphahr.oss-cn-beijing.aliyuncs.com/public/d32bfbcd863860b41535f5fc1923396d.%E6%98%93%E7%A5%96%E6%B1%9F-%E7%A8%8E%E5%8A%A1%E8%B4%9F%E8%B4%A3%E4%BA%BA-%E4%B8%AD%E5%A4%96%E5%90%88%E8%90%A5%EF%BC%88%E5%90%88%E8%B5%84%C2%B7%E5%90%88%E4%BD%9C%EF%BC%89-%E7%94%B7-32%E5%B2%81-%E7%A1%95%E5%A3%AB-8%E5%B9%B4%E4%BB%A5%E4%B8%8A%E5%B7%A5%E4%BD%9C%E7%BB%8F%E9%AA%8C%E7%8C%8E%E8%81%98%E7%AE%80%E5%8E%86.docx',
        },
        documentType: 'word',
        editorConfig: {
          actionLink: null,
          callbackUrl: 'http://47.93.158.22:11000/example/track?filename=new.docx&useraddress=27.47.132.115',
          coEditing: null,
          createUrl: null,
          customization: {
            about: false,
            comments: false,
            feedback: false,
            forcesave: false,
            submitForm: false,
            compactHeader: true,
            compactToolbar: true,
            hideRightMenu: true,
            hideRulers: true,
            toolbarNoTabs: true,
            // zoom: -1,
            features: {
              spellcheck: false,
            },
            integrationMode: 'embed',
            logo: {
              image: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/assets/alpha-logo.png',
            },
          },
          user: {
            group: '',
            id: app.user._id,
            name: app.user.account || 'test',
          },
          region: 'zh-CN',
          lang: 'zh-CN',
          plugins: false,
        },
        mode: 'view',
        height: '100%',
        width: '100%',
        type: 'desktop',
      },
      originalname: '',
      documentType: 'word',
      fileType: 'docx',
      md5: '',
      docEditor: null,
    }
  },
  computed: {
    suffix() {
      const previewUrl = this.previewUrl
      return (previewUrl && previewUrl.substr(previewUrl.lastIndexOf('.') + 1)) || ''
    },
    isAdmin() {
      return app.user.角色 && app.user.角色.includes('管理员')
    },
    isOfficeUrl() {
      const wordTypeReg = /(\.doc)|(\.docm)|(\.docx)|(\.docxf)|(\.dot)|(\.dotm)|(\.dotx)|(\.epub)|(\.fodt)|(\.fb2)|(\.htm)|(\.html)|(\.mht)|(\.odt)|(\.oform)|(\.ott)|(\.oxps)|(\.pdf)|(\.rtf)|(\.txt)|(\.djvu)|(\.xml)|(\.xps)/
      const excelTypeReg = /(\.csv)|(\.fods)|(\.ods)|(\.ots)|(\.xls)|(\.xlsb)|(\.xlsm)|(\.xlsx)|(\.xlt)|(\.xltm)|(\.xltx)/
      const pptTypeReg = /(.fodp)|(\.odp)|(\.otp)|(\.pot)|(\.potm)|(\.potx)|(\.pps)|(\.ppsm)|(\.ppsx)|(\.ppt)|(\.pptm)|(\.pptx)/
      return wordTypeReg.test(this.previewUrl) || excelTypeReg.test(this.previewUrl) || pptTypeReg.test(this.previewUrl)
    },
    isImgUrl() {
      return /\.(jpg|png|jpeg)/.test(this.previewUrl)
    },
    isFinance() {
      return app.user.角色 && app.user.角色.includes('财务')
    },
  },
  watch: {
    width(val) {
      this.boxWidth = val
    },
  },
  mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
    this.config.events = {
      onError: this.destoryEditor(),
      onRequestClose: this.destoryEditor(),
    }
  },
  methods: {
    downloadFile() {
      if (this.file) download(this.file)
    },
    max() {
      this.$el.style.left = 0
      this.$el.style.top = '60px'
      this.$el.style.width = '100vw'
      this.$el.style.height = 'calc(100vh - 60px)'
      this.isMax = true
    },
    revert() {
      this.$el.style.left = 0
      this.$el.style.top = '60px'
      this.$el.style.width = '40vw'
      this.$el.style.height = 'calc(100vh - 60px)'
      this.isMax = false
    },
    close() {
      this.destoryEditor()
      this.visible = false
    },
    loadFileByUrl(url) {
      this.previewUrl = url
      this.show()
    },
    destoryEditor() {
      this.docEditor && this.docEditor.destroyEditor()
      this.docEditor = null
    },
    async getFile(file) {
      console.log(file)
      const { md5, fileId, _id } = file
      if (!md5 && !fileId && !_id) return
      this.loading = true
      this.file = file
      try {
        const query = md5 ? { md5 } : fileId || _id ? { _id: fileId || _id } : undefined
        const src = await window.app.service('file').buildPreview(query)
        const url = src.url
        if (window.location.origin.indexOf('https://') !== -1) {
          this.previewUrl = url.replace('http://', 'https://')
        } else if (window.location.origin.indexOf('http://') !== -1) {
          this.previewUrl = url.replace('https://', 'http://')
        }
        this.documentType = src.documentType
        this.originalname = src.originalname
        this.fileType = src.fileType
        this.md5 = src.md5
        this.show()
      } catch (error) {
        this.$message.error(`预览：${(error.response && error.response.message) || error.message}`)
        this.close()
      }
      this.loading = false
    },
    show() {
      // this.revert()
      this.visible = true
      this.zindex = app.root.dragindex++
      if (this.isOfficeUrl) {
        this.config.documentType = this.documentType
        this.config.document.fileType = this.fileType
        this.config.document.key = this.md5
        this.config.document.title = this.originalname
        this.config.document.url = this.previewUrl
        this.config.events = {
          onError: this.destoryEditor(),
          onRequestClose: this.destoryEditor(),
        }
        if (this.isShuju || this.isAdmin) {
          this.config.document.permissions.copy = true
        }
      }
      this.$nextTick(() => {
        if (!this.docEditor && this.isOfficeUrl) {
          this.docEditor = new window.DocsAPI.DocEditor('testIframeSalaryEdit', this.config)
        }
        this.revert()
      })
    },
    domdrag($el, event) {
      let startX, startY, clientX, clientY
      let isDrag = false
      event.preventDefault()
      // $el.style.zIndex = app.root.dragindex++
      startX = $el.offsetLeft
      startY = $el.offsetTop
      clientX = event.clientX
      clientY = event.clientY
      isDrag = true
      document.addEventListener('mousemove', e => {
        if (isDrag) {
          e.preventDefault()
          $el.style.left = `${e.clientX - clientX + startX}px`
          $el.style.top = `${e.clientY - clientY + startY}px`
        }
      })
      document.addEventListener('mouseup', e => {
        isDrag = false
      })
    },
    resize(oParent, handle, isLeft, isTop, lockX, lockY) {
      const { dragMinWidth, dragMinHeight, $el } = this
      const showCover = val => (this.dragLeft = val)
      handle.onmousedown = e => {
        showCover(true)
        const event = e || window.event
        const disX = event.clientX - handle.offsetLeft
        const disY = event.clientY - handle.offsetTop
        const iParentTop = oParent.offsetTop
        const iParentLeft = oParent.offsetLeft
        const iParentWidth = oParent.offsetWidth
        const iParentHeight = oParent.offsetHeight

        const iframe = $el.querySelector('#iframe')
        let iframeDocument = iframe.contentDocument

        if (iframeDocument) {
          iframeDocument.onmousemove = mouseMove
          iframeDocument.onmouseup = mouseUp
        } else {
          iframe.onload = function() {
            iframeDocument = iframe.contentDocument
            iframeDocument.onmousemove = mouseMove
            iframeDocument.onmouseup = mouseUp
          }
        }

        document.onmousemove = mouseMove
        document.onmouseup = mouseUp

        function mouseUp() {
          document.onmousemove = null
          document.onmouseup = null
          iframeDocument && (iframeDocument.onmousemove = null)
          iframeDocument && (iframeDocument.onmouseup = null)
          showCover(false)
        }
        function mouseMove(e) {
          const event = e || window.event
          const iL = event.clientX - disX
          const iT = event.clientY - disY
          const maxW = document.documentElement.clientWidth - oParent.offsetLeft - 2
          const maxH = document.documentElement.clientHeight - oParent.offsetTop - 2
          let iW = isLeft ? iParentWidth - iL : handle.offsetWidth + iL
          let iH = isTop ? iParentHeight - iT : handle.offsetHeight + iT
          const newTop = iParentTop + iT

          isLeft && iW >= dragMinWidth && (oParent.style.left = `${iParentLeft + iL}px`)
          iW < dragMinWidth && (iW = dragMinWidth)
          iW > maxW && (iW = maxW)
          lockX || (oParent.style.width = `${iW}px`)
          isTop && iH >= dragMinHeight && (oParent.style.top = `${newTop < 41 ? 41 : newTop}px`)
          iH < dragMinHeight && (iH = dragMinHeight)
          iH > maxH && (iH = maxH)
          lockY || (oParent.style.height = `${iH}px`)
          return false
        }

        return false
      }
    },
  },
}
</script>

<style src="../../statics/css/cvpreview.css"></style>
